'use strict';
/*
import {
    lockScroll,
    unlockScroll
} from '../util/common';
*/
import { newModalFromString, ModalShowHide } from '../components/modal';

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');

        $results.find('.' + $(this)[0].className.replace(/ /g, '.')).addClass('active');
    });

    var refId = $('.refinements.cell').children('.is-open').data('refinementId');
    $($results).find(`[data-refinement-id="${refId}"]`).addClass('is-open');
    updateDom($results, '.refinements');
    // updateFiltersContainer();
    updateCheckedCounter();
}

function updateSpecialRefinementsCarousel() {
    const $specialRefinements = $('.special-refinements');

    if (
        Foundation.MediaQuery.atLeast('large') ||
        (!Foundation.MediaQuery.atLeast('large') && $specialRefinements.find('.special-refinement--tezenis').length < 5)
    ) {
        $specialRefinements.find('.placeholder-refinement').remove();
    }

    $specialRefinements.slick({
        slidesToShow: 6,
        dots: false,
        infinite: false,
        prevArrow: $specialRefinements.prev('.slick-arrow'),
        nextArrow: $specialRefinements.next('.slick-arrow'),
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 4.5,
                    swipeToSlide: true
                }
            }
        ]
    });

    var selectedIndex = $('.special-refinements .selected').index() + 1;
    var maximumItems = 6;
    if (!Foundation.MediaQuery.atLeast('medium')) {
        maximumItems = 4;
    }
    if (selectedIndex > maximumItems) {
        $specialRefinements.slick('slickGoTo', selectedIndex - maximumItems);
    }

    // Removes duplicate selected element
    if ($('.special-refinement.selected').length > 1) {
        $('.special-refinement.selected:not(:first-of-type)').removeClass('selected');
    }
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };
    // Update DOM elements that do not require special handling
    [
        '.filters-and-order',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.modal-footer__actions',
        '.footer-pagination',
        '.filter.sort-order',
        '.max-step-plp'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
/*
function getContent ($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}
*/

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
/*
function updateSortOptions (response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}
*/
/*
function updateFiltersContainer () {
    if ($('.active-filters-list').text().trim().length === 0) {
        $('.active-filters-list').hide();
    }
}
*/

function updateCheckedCounter() {
    const filters = $('#filtersModal').find('.filter');

    for (let filter of filters) {
        const inputType = $(filter).hasClass('sort-order') ? 'radio' : 'checkbox';
        const checkedCount = $(filter).find(`input[type="${inputType}"]:checked`).length / 2;
        const filterId = $(filter).find(`input[type="${inputType}"]`).attr('name');
        const filterCounterLabel = $(filter).find(`.${filterId}-checked-counter`);

        if (filterCounterLabel) {
            if (checkedCount === 0) {
                filterCounterLabel.text('');
                filterCounterLabel.hide();
            } else {
                filterCounterLabel.text(`(${checkedCount})`);
                filterCounterLabel.show();
            }
        }

        if (checkedCount) {
            expandFilter(filter);
        }
    }
}

function getOpenModalFilterIds() {
    const openFilterIds = [];

    $('#filtersModal .filter').each(function (index, filter) {
        if ($(filter).find('.filter-body').is(':visible')) {
            openFilterIds.push($(filter).attr('id'));
        }
    });

    return openFilterIds;
}

function restoreModalOpenFilters(openFilterIds) {
    if (!openFilterIds || !openFilterIds.length) {
        return;
    }

    openFilterIds.forEach(function (filterId) {
        const filter = $('#filtersModal .filter[id="' + filterId + '"]');

        if (!filter.length) {
            return;
        }

        filter.addClass('is-open');
        expandFilter(filter);
    });
}

function restoreModalFocus(refinementId, valueId, href) {
    if (!refinementId) {
        return;
    }

    let targetValue = $('#filtersModal .filter[id="' + refinementId + '"] a[data-value-id]').filter(function () {
        return $(this).data('valueId') === valueId;
    }).first();

    if (!targetValue.length && href) {
        targetValue = $('#filtersModal .filter[id="' + refinementId + '"] a[href]').filter(function () {
            return $(this).attr('href') === href;
        }).first();
    }

    if (targetValue.length) {
        window.raf(function () {
            targetValue.focus();
        });
    }
}

function toggleAccordion(target) {
    const filterBody = $(target).next('.filter-body');

    if (filterBody.is(':visible')) {
        $(target).find('.triangle').removeClass('is-open');
        $(filterBody).slideUp('fast');
    } else {
        $(target).find('.triangle').addClass('is-open');
        $(filterBody).slideDown('fast');
    }
}
/*
function collapseFilter (filter) {
    const filterAccordion = $(filter).find('.filter-accordion');
    const filterBody = $(filter).find('.filter-body');

    if (filterBody.is(':visible')) {
        $(filterAccordion).find('.triangle').removeClass('is-open');
        $(filterBody).slideUp('fast');
    }
}
*/

/*
function collapseAllFilters () {
    const filters = $('#filtersModal').find('.filter');

    filters.each(function (index, filter) {
        collapseFilter(filter);
    });
}
*/

function expandFilter(filter) {
    const filterAccordion = $(filter).find('.filter-accordion');
    const filterBody = $(filter).find('.filter-body');

    if (!filterBody.is(':visible')) {
        $(filterAccordion).find('.triangle').addClass('is-open');
        $(filterBody).slideDown('fast');
    }
}

function expandSpecialFilters() {
    const specialFilterIds = {
        color: 'color',
        size: 'size'
    };

    Object.keys(specialFilterIds).forEach(function (id) {
        const filter = $('#filtersModal').find(`#${id}`);
        expandFilter(filter);
    });
}

function resetCheckedFiltersState() {
    const checkedFilterLinks = $('#filtersModal li a, .filter-value a, .swatch-filter a').filter(function () {
        return !!$(this).data('checked');
    });

    checkedFilterLinks.each(function () {
        $(this).data('checked', false);
        $(this).find('.bucket-swatch').removeClass('cc-selected');
    });

    return checkedFilterLinks.length;
}

function filterSearchApi(e, href) {
    return new Promise((resolve, reject) => {
        const currentTarget = $(e.currentTarget);
        const selectedRefinementId = currentTarget.closest('.filter, .refinement').attr('id');
        const selectedValueId = currentTarget.data('valueId');
        const selectedHref = currentTarget.attr('href');
        const openModalFilterIds = getOpenModalFilterIds();

        $.ajax({
            url: href || e.currentTarget.href,
            data: {
                page: $('.grid-footer').data('page-number'),
                selectedUrl: href || e.currentTarget.href
            },
            method: 'GET',
            success: function (response) {
                // save IDs of open refinements for mobile UI
                if (document.querySelector('#quiz-template-identifier')) {
                    var quizStep = window.sessionStorage.getItem('quiz_step');
                    history.pushState({step: quizStep}, '', this.url);
                } else if (this.url.indexOf('Search-UpdateGrid') === -1) {
                    history.pushState({}, '', this.url);
                }
                let openRefinementIDs = [];
                $('.refinements .refinement.is-open').each((index, element) => {
                    openRefinementIDs.push($(element).data('refinement-id'));
                });

                parseResults(response);
                restoreModalOpenFilters(openModalFilterIds);
                restoreModalFocus(selectedRefinementId, selectedValueId, selectedHref);

                if (document.querySelectorAll("#quiz-template-identifier").length > 0) {
                    var stepExist = sessionStorage.getItem('quiz_step');
                    if (typeof stepExist !== 'undefined' && stepExist !== null) {
                        if (parseInt(stepExist) === 10) {
                            $('.max-step-plp .label-cta-topseller').first().removeClass("hidden");
                            var productQuizCount = document.querySelectorAll('.js-quiz-product').length;
                            $('.product-quiz-number').text(productQuizCount);
                        }
                    }
                }

                for (let i = 0; i < openRefinementIDs.length; i++) {
                    const refinementId = openRefinementIDs[i];
                    if (!$(`.refinements .refinement[data-refinement-id="${refinementId}"]`).parent().hasClass('refinements--tezenis')) {
                        $(`.refinements .refinement[data-refinement-id="${refinementId}"]`).addClass('is-open');
                    }
                }

                let responseDom = document.createElement('html');
                try {
                    let filterNotApplied = $('.refinements input[type="checkbox"]:checked').length === 0;
                    let listType = clearAll || filterNotApplied ? 'listing' : 'filter_applied';
                    if (document.querySelectorAll("#quiz-template-identifier").length > 0) {
                        listType = 'quiz_bras';
                    }
                    let analyticsItems = [];

                    responseDom.innerHTML = response;

                    let productElements = responseDom.querySelectorAll('.productListingItem');

                    for (let productElement of productElements) {
                        let analyticsObject = {};

                        for (let elemAttribute of productElement.attributes) {
                            if (elemAttribute.nodeName.startsWith('data-')) {
                                let analyticsProperty = elemAttribute.nodeName.replace('data-', '');
                                let analyticsValue = productElement.getAttribute(elemAttribute.nodeName);
                                analyticsObject[analyticsProperty] = analyticsValue;
                            }
                        }
                        analyticsItems.push(analyticsObject);
                    }

                    if (listType === 'filter_applied') {
                        document.querySelector('.analytics.pageType.listing').className = 'analytics pageType listing filteredProducts';
                    } else {
                        document.querySelector('.analytics.pageType.listing').className = localStorage.getItem('classNameBeforeFilters');
                    }

                    let currentPageProductList = document.querySelector('#product-search-results')
                        ? document.querySelector('#product-search-results').querySelectorAll('[data-item_list_name]')
                        : [];
                    for (let productData of currentPageProductList) {
                        productData.setAttribute('data-item_list_name', listType);
                    }

                    $('body').trigger('listing:filter_or_sort_applied', {
                        dataArray: analyticsItems,
                        listType: listType
                    });
                } catch (e) {
                    console.log(e);
                    $.spinner().stop();
                }

                if ($(e.currentTarget).hasClass('reset')) {
                    location.reload();
                }

                href && responseDom.querySelectorAll('.cachedFilters') && resolve(responseDom.querySelectorAll('.cachedFilters'));

                $.spinner().stop();
            },
            error: function (er) {
                console.log(er);
                $.spinner().stop();
            }
        });
        let clearAll = $(e.currentTarget).hasClass('remove-all');
    });
}

module.exports = {
    scrollBehaviorsInListing: function () {
        var headerDiv = $('.main-header');

        if ($('.search-results__refinements-container').length > 0) {
            $(window).scroll(function () {
                if (
                    $(window).scrollTop() + headerDiv.height() >
                    $('.search-results__refinements-container').position().top + $('.search-results__refinements-container').height()
                ) {
                    $('.search-results__refinements-scroll').css({
                        transform: 'translateY(' + headerDiv.height() + 'px)',
                        transition: 'all 0.7s ease 0s',
                        visibility: 'visible'
                    });
                } else {
                    $('.search-results__refinements-scroll').css({
                        transform: 'translateY(calc(-100% - ' + headerDiv.height() + 'px))',
                        transition: 'all 0.7s ease 0s',
                        visibility: 'hidden'
                    });
                }
            });

            if (!Foundation.MediaQuery.atLeast('medium')) {
                var prevScrollpos = window.pageYOffset;

                // Get the header element and it's position
                $(window).scroll(function () {
                    var currentScrollPos = window.pageYOffset;
                    // if scrolling down, let it scroll out of view as normal
                    if (prevScrollpos <= currentScrollPos && currentScrollPos > 50) {
                        headerDiv.removeClass('header-visible');
                        $('.search-results__refinements-scroll, .main-header').css({
                            top: '-' + headerDiv.height() + 'px',
                            transition: 'all 0.3s ease'
                        });
                        $('.search-results__refinements-scroll').css('visibility', 'hidden');
                    } else {
                        // otherwise if we're scrolling up, fix the nav to the top
                        headerDiv.addClass('header-visible');
                        $('.search-results__refinements-scroll, .main-header').css({ top: '0', transition: 'all 0.3s ease' });
                        if (
                            $(window).scrollTop() + headerDiv.height() >
                            $('.search-results__refinements-container').position().top + $('.search-results__refinements-container').height()
                        ) {
                            $('.search-results__refinements-scroll').css('visibility', 'visible');
                        }
                    }

                    prevScrollpos = currentScrollPos;
                });
            }
        }
    },
    updateLabelsOnProductCardHover: function () {
        $('.js-notify-icon')
            .on('mouseenter', function (e) {
                var quickBuySizesContainer = $(e.currentTarget).parents('.quick-buy-sizes');
                var imageContainer = $(e.currentTarget).parents('.image-container');
                var bottomPosition =
                    $(quickBuySizesContainer).innerHeight() +
                    parseInt($(quickBuySizesContainer).css('bottom'), 10) +
                    parseInt($('.card-overlay__label-cta--soldout', imageContainer).css('margin-bottom'), 10);
                $('.quick-buy-sizes__label--available, .quick-buy-sizes__label--unavailable', quickBuySizesContainer).toggle();
                imageContainer.find('.card-overlay__label-cta--soldout').removeClass('hidden').css('bottom', bottomPosition);
                if (
                    $(e.currentTarget).parents('.js-pdp-link').find('.is-on-sale').length > 0 &&
                    !$(e.currentTarget).parents('.js-pdp-link').find('.card-overlay__label-cta--color-on-sale').hasClass('hidden')
                ) {
                    $(e.currentTarget).parents('.js-pdp-link').find('.card-overlay__label-cta--color-on-sale').addClass('hidden');
                }
            })
            .on('mouseleave', function (e) {
                var quickBuySizesContainer = $(e.currentTarget).parents('.quick-buy-sizes');
                var imageContainer = $(e.currentTarget).parents('.image-container');
                $('.quick-buy-sizes__label--available, .quick-buy-sizes__label--unavailable', quickBuySizesContainer).toggle();
                if (imageContainer.find('.soldoutBox').hasClass('hidden')) {
                    $('.card-overlay__label-cta--soldout').addClass('hidden');
                } else {
                    $('.card-overlay__label-cta--soldout').removeAttr('style');
                }
                if (
                    $(e.currentTarget).parents('.js-pdp-link').find('.is-on-sale').length > 0 &&
                    $(e.currentTarget).parents('.js-pdp-link').find('.card-overlay__label-cta--color-on-sale').hasClass('hidden')
                ) {
                    $(e.currentTarget).parents('.js-pdp-link').find('.card-overlay__label-cta--color-on-sale').removeClass('hidden');
                }
            });
        $('.js-lowInStock-icon')
            .on('mouseenter', function (e) {
                var quickBuySizesContainer = $(e.currentTarget).parents('.quick-buy-sizes');
                $('.quick-buy-sizes__label--available, .quick-buy-sizes__label--lowInStock', quickBuySizesContainer).toggle();
            })
            .on('mouseleave', function (e) {
                var quickBuySizesContainer = $(e.currentTarget).parents('.quick-buy-sizes');
                $('.quick-buy-sizes__label--available, .quick-buy-sizes__label--lowInStock', quickBuySizesContainer).toggle();
            });

        $('.js-pdp-link')
            .on('mouseenter', function (e) {
                if ($(e.currentTarget).find('.is-on-sale').length > 0) {
                    var quickBuySizesContainer = $(e.currentTarget).find('.quick-buy-sizes');
                    var imageContainer = $(e.currentTarget).find('.image-container');
                    var bottomPosition =
                        $(quickBuySizesContainer).innerHeight() +
                        parseInt($(quickBuySizesContainer).css('bottom'), 10) +
                        parseInt($('.card-overlay__label-cta--color-on-sale', imageContainer).css('margin-bottom'), 10);
                    // If omnibus regular price label is present for some countries, do not show sale tag on tile image
                    if ($(e.currentTarget).find('.js-priceInfo-discountValue').length <= 0) {
                        $('.card-overlay__label-cta--color-on-sale', e.currentTarget).removeClass('hidden').css('bottom', bottomPosition);
                    }
                }
            })
            .on('mouseleave', function (e) {
                $('.card-overlay__label-cta--color-on-sale').addClass('hidden');
            });
    },
    toggleFiltersModal: function () {
        let lastFocusedElement;
        // Accessibility trigger
        $('.openFiltersModal').on('keydown', function (e) {
            if (e.type === 'keydown' && e.originalEvent.keyCode === 13) {
                $(e.currentTarget).trigger('click');
            }
        });

        $('body').on('click', '.openFiltersModal', function (e) {
            e.stopPropagation();
            lastFocusedElement = e.currentTarget;
            if ($('#filtersModal').length > 0) {
                const openFiltersModal = new ModalShowHide('#filtersModal', 'isFiltersModalOpen', true, '.js-filtersModal');
                openFiltersModal.show('isFiltersModalOpen');
                expandSpecialFilters();
                
                window.raf(function () {
                    $('#filtersModal .modal-close-filters').focus();
                });
            }
        });

        $('body').on('click keydown', '#filtersModal .modal-close', function (e) {
            if (e.type === 'keydown' && !(e.originalEvent.keyCode === 13)) {
                return;
            }
            e.stopPropagation();
            
            if (lastFocusedElement) {
                $(lastFocusedElement).focus();
            }
            location.reload();
        });

        $('.filters-modal').on('click', function (e) {
            if (!$(e.target).closest('#filtersModal').length) {
                if (lastFocusedElement) {
                    $(lastFocusedElement).focus();
                }
                location.reload();
            }
        });
    },

    toggleFilterAccordion: function () {
        $('body').on('click', '.filter-accordion', function (e) {
            e.stopPropagation();
            toggleAccordion(this);
        });
    },

    sort: function () {
        // Accessibility trigger
        $('.filter-body span.radio-input').on('keydown', function (e) {
            if (e.type === 'keydown' && e.originalEvent.keyCode === 13) {
                $(e.currentTarget).siblings('[name=sort-order]').trigger('change');
            }
        });

        $('.container').on('click', '.sort-order .filter-body', function (e) {
            e.stopPropagation();
        });

        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            location.href = this.value;
        });
    },
    /*
    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');

            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: {
                    selectedUrl: showMoreUrl
                },
                method: 'GET',
                success: function (response) {
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $('body').trigger('search:showMoreContentLoaded');
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    */

    applyFilter: function (href, searchElement) {
        if (href) {
            $.spinner().start();

            $(this).trigger('search:filter', searchElement);

            const availableFilters = filterSearchApi(searchElement, href);
            return availableFilters;
        } else {
            // Handle refinement value selection and reset click
            if (document.querySelector('.analytics.pageType.listing')) {
                localStorage.setItem('classNameBeforeFilters', document.querySelector('.analytics.pageType.listing').className);
            }
            $('.container').on(
                'click',
                '#filtersModal li a, #filterModal a.reset, .filters-and-order a.reset, .refinement-bar a.reset, .filter-value a, .swatch-filter a',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    if ($(this).hasClass('disabled') || $(this).prop('disabled')) {
                        return false;
                    }
                    let checkFilterState = $(this).data('checked');
                    $(this).data('checked', !checkFilterState);
                    $(this).find('.bucket-swatch').toggleClass('cc-selected', !checkFilterState);

                    $.spinner().start();
                    if (checkFilterState) {
                        $(this).trigger('search:filter', e);
                    }

                    filterSearchApi(e);
                }
            );
        }
    },

    specialRefinements: function () {
        updateSpecialRefinementsCarousel();
    },
    /*
    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results .result-count'));
            $('.show-more-content').remove();
        });
    },
    */
    /*
    handlePaginationNavigation: function () {
        // Listen for navigation click...
        var rangeLeft = $('ul.pagination').data('page-range-left');
        var rangeRight = $('ul.pagination').data('page-range-right');
        var pageTotal = $('ul.pagination').data('page-total');

        var updateRangeUI = function () {
            $('.pagination__button').removeClass('pagination__button--show');
            $('.pagination__button').each(function () {
                if (rangeLeft <= $(this).data('page-link-number') && $(this).data('page-link-number') <= rangeRight) {
                    $(this).addClass('pagination__button--show');
                }
            });
        };

        $('.pagination__button--nav-left').on('click', function () {
            $('.pagination__button--nav-left').removeClass('hide-nav');
            $('.pagination__button--nav-right').removeClass('hide-nav');
            if (rangeLeft === 1) {
                $('.pagination__button--nav-left').addClass('hide-nav');
            }
        });

        $('.pagination__button--nav-right').on('click', function () {
            $('.pagination__button--nav-left').removeClass('hide-nav');
            $('.pagination__button--nav-right').removeClass('hide-nav');
            if (rangeRight.toString() === pageTotal.toString()) {
                $('.pagination__button--nav-right').addClass('hide-nav');
            }
        });
    },
    */

    /**
     * Remove empty whitespace when no filter is active
     */
    /*
    handleFilters: function () {
        updateFiltersContainer();
    },
    */

    checkFindInStoreEnabled: function () {
        // necessary in order to avoid checking the findinstore custom pref in every product tile
        var isFindInStoreEnabled = $('.container.search-results').data('isFindInStoreEnabled');
        if (isFindInStoreEnabled) {
            $('.soldoutBox .add-to-wish-list-coming-soon').remove();
            $('.soldoutBox .find-in-store-tile').removeClass('hide');
        } else {
            $('.soldoutBox .find-in-store-tile').remove();
            $('.soldoutBox .add-to-wish-list-coming-soon').removeClass('hide');
        }
    },

    plpFindInStore: function () {
        $('.soldoutBox .find-in-store-tile').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var sizeModalUrl = $(e.currentTarget).data('sizeModalUrl');
            $.spinner().start();
            $.ajax({
                url: sizeModalUrl,
                method: 'GET',
                success: function (data) {
                    $.spinner().stop();
                    var modal = newModalFromString(data, false, ['fis-select-size-modal']);
                    modal.open();
                    $('.fis-select-size-modal').on('click', '.tingle-modal__closeIcon', function () {
                        modal.close();
                        modal.destroy();
                    });
                    var modalBox = $(modal.modalBox);
                    var dataContainer = $('#findinstore.findinstore-wrapper');
                    var prodData = $(e.currentTarget).closest('.product').find('.productListingItem');
                    dataContainer.data('plpPid', prodData.data('id'));
                    dataContainer.data('plpColor', prodData.data('variant'));
                    modalBox.on('click', '.size-selector', function (e) {
                        var selectedSize = $(e.currentTarget);
                        modalBox.find('.size-selector').removeClass('selected');
                        selectedSize.addClass('selected');
                        dataContainer.data('plpSize', selectedSize.data('attrValue'));
                        modalBox.find('.find-in-store-btn').prop('disabled', false);
                    });
                    modalBox.on('click', '.find-in-store-btn', function () {
                        setTimeout(function () {
                            modal.close();
                            modal.destroy();
                        }, 500);
                    });
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }
};
